export const videoTitleMaxLength = 150
